// extracted by mini-css-extract-plugin
module.exports = {"reKybContent":"Modal_reKybContent__3xvql","updateBtn":"Modal_updateBtn__22Wvm","modalAlertText":"Modal_modalAlertText__1nUFq"};